// empty danceChart as it starts in the editor
var danceChart = {
  title: '',
  artist: '',
  offset: 0,
  bpm: 200,
  videoId: '',
  videoStart: 0,
  videoEnd: 0,
  moves: [],
  chartId: '',
  songId: ''
}

export default danceChart
